<div>
	<div class="row">
		<div class="col-lg-6 d-flex">
			<span class="results">{{collectionSize}} {{ labels().ARCHIVE_TABLE_COMPONENT_RESULTS }} </span>
		</div>
	</div>
</div>

<div class="panel panel-thead">
	<div class="row no-gutters">
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_PATIENT_ID }}</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_PLAN_ID }}</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_PLAN_SIDE }}</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_PLAN_TYPE }}</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_PLAN_BONE_TYPE }}</div>
		<div class="col no-link">
			{{ labels().ARCHIVE_TABLE_COMPONENT_PLAN_CREATION_DATE }}
			<br>
			<span data-testid="SUBSYS2_ARCHIVE_HEADER_FORMATDATE_TXT" class="date-format">{{ dateFormat }}</span>
		</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_VIEW_CASE }}</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_IMAGE_PREOP_AP }}</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_IMAGE_PREOP_LT }}</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_IMAGE_POSTOP_AP }}</div>
		<div class="col no-link">{{ labels().ARCHIVE_TABLE_COMPONENT_IMAGE_POSTOP_LT }}</div>
	</div>
</div>

@for (item of list; track item.caseId) {
<div class="panel panel-tr">
	<div class="row no-gutters">
		<div class="col">{{item.patientNumber}}</div>
		<div class="col">{{item.caseNumber}}</div>
		<div class="col">{{item.side | anatomicalSideLabel}}</div>
		<div class="col">{{item.caseType | planTypeLabel}}</div>
		<div class="col">{{item.boneType | boneTypeLabel}}</div>
		<div class="col">{{item.caseCreationDate | convertDate:false}}</div>
		<div class="col">
			@if (item.idToViewCase) {
			<i class="material-icons action" (click)="viewCase(item.idToViewCase)"
				(keypress)="viewCase(item.idToViewCase)">description</i>
			}
		</div>
		<div class="col">
			@if (item.idToImageAPpreop) {
			<i class="material-icons action" (click)="viewImage(item.idToImageAPpreop)"
				(keypress)="viewImage(item.idToImageAPpreop)">description</i>
			}
		</div>
		<div class="col">
			@if (item.idToImageLATpreop) {
			<i class="material-icons action" (click)="viewImage(item.idToImageLATpreop)"
				(keypress)="viewImage(item.idToImageLATpreop)">description</i>
			}
		</div>
		<div class="col">
			@if (item.idToImageAPpostop) {
			<i class="material-icons action" (click)="viewImage(item.idToImageAPpostop)"
				(keypress)="viewImage(item.idToImageAPpostop)">description</i>
			}
		</div>
		<div class="col">
			@if (item.idToImageLATpostop) {
			<i class="material-icons action" (click)="viewImage(item.idToImageLATpostop)"
				(keypress)="viewImage(item.idToImageLATpostop)">description</i>
			}
		</div>
	</div>
</div>
}

<archive-pagination />